import { hasWritePermission } from "../../PermissionUtility";

export default function tokenTransferInputs(values) {
  console.log(values, "tokenTransferInputs")
  const canWriteUsers = hasWritePermission('tokentransferlimit');
  
  
  const isDisabled = values.mode === "view" || !values.isEnabled;
  
  return [
    
    {
      shape: "div",
      type: "wrapper",
      className: "",
      sx: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gridColumnGap: "100px",
        mt: 3,
        opacity: values.isEnabled ? 1 : 0.6, 
      },
      children: [
        {
          shape: "input",
          type: "number",
          name: "min_tokens_to_transfer",
          title: "Define minimum tokens to transfer",
          label: "Define minimum tokens to transfer",
          placeholder: "Enter the value",
          width: '100%',
          disabled: isDisabled, 
          inputProps: {
            step: "0.01", 
            min: "0.01",
          },
          validation: {
            required: values.mode !== "view" && values.isEnabled, 
            requiredMessage: "Minimum tokens to transfer can't be empty",
            pattern: /^\d+(\.\d{1,2})?$/,
            patternMessage: "Please enter a valid number (up to 2 decimal places)",
            hiddenRules: [
              {
                mode: "view",
              },
            ],
          },
        },
        {
          shape: "input",
          type: "number",
          name: "max_tokens_to_transfer",
          title: "Define maximum tokens to transfer",
          label: "Define maximum tokens to transfer",
          placeholder: "Enter the value",
          width: '100%',
          disabled: isDisabled, 
          inputProps: {
            step: "0.01", // Allow decimal values
            min: "0.01",
          },
          validation: {
            required: values.mode !== "view" && values.isEnabled, 
            requiredMessage: "Maximum tokens to transfer can't be empty",
            pattern: /^\d+(\.\d{1,2})?$/,
            patternMessage: "Please enter a valid number (up to 2 decimal places)",
            hiddenRules: [
              {
                mode: "view",
              },
            ],
          },
        }
      ],
    },

    
    {
      shape: "div",
      type: "wrapper",
      className: "",
      sx: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gridColumnGap: "100px",
        mt: 3,
        opacity: values.isEnabled ? 1 : 0.6, 
      },
      children: [
        {
          shape: "input",
          type: "number",
          name: "max_transfers_per_month",
          title: "Define maximum no of transfers per month",
          label: "Define maximum no of transfers per month",
          placeholder: "Enter the value",
          width: '100%',
          disabled: isDisabled, 
          inputProps: {
            min: "1",
            step: "1", // Only whole numbers for transfers
          },
          validation: {
            required: values.mode !== "view" && values.isEnabled, // Only required if enabled
            requiredMessage: "Maximum transfers per month can't be empty",
            pattern: /^\d+$/,
            patternMessage: "Please enter a valid whole number",
            hiddenRules: [
              {
                mode: "view",
              },
            ],
          },
        },
        
        {
          type: "textview",
          content: '',
        },
      ],
    },

    
    {
      shape: "div",
      type: "wrapper",
      className: "",
      sx: { 
        display: "flex", 
        justifyContent: "flex-start", 
        mt: 4,
        opacity: values.isEnabled ? 1 : 0.6, 
      },
      children: [
        ...(canWriteUsers ? [
        {
          shape: "button",
          type: "action",
          title: values.mode === "view" ? "Edit" : "Update",
          submitButton: true,
          name: "Save",
          disabled: !values.isEnabled, 
          sx: {
            px: 4,
          },
          validation: {
            hiddenRules: [
              {
                mode: "view",
              },
            ],
          },
        },
        {
          shape: "button",
          type: "button",
          title: "Cancel",
          name: "Cancel",
          sx: {
            px: 4,
            backgroundColor: 'transparent',
            color: '#6366f1',
            border: '1px solid #6366f1',
            borderRadius: '8px',
            '&:hover': {
              backgroundColor: '#f8fafc',
            },
          },
          onClick: () => {
            window.history.back();
          },
        } ] : []),
      ],
    },
  ];
}